import "../i18n";

type affType = {
  player: string;
  deposit: string;
  cashout: string;
  winLoss: string;
  platformFee: string;
  bonus: string;
  paymentFee: string;
  commission: string;
};

export const dataAffiliate: affType[] = [
  {
    player: "A",
    deposit: "10000",
    cashout: "2000",
    winLoss: "8000",
    platformFee: "1600",
    bonus: "0",
    paymentFee: "420",
    commission: "1815"
  },
  {
    player: "B",
    deposit: "50000",
    cashout: "0",
    winLoss: "50000",
    platformFee: "10000",
    bonus: "0",
    paymentFee: "1750",
    commission: "11475"
  },
  {
    player: "C",
    deposit: "0",
    cashout: "0",
    winLoss: "0",
    platformFee: "0",
    bonus: "200",
    paymentFee: "0",
    commission: "-60"
  },
  {
    player: "D",
    deposit: "500",
    cashout: "0",
    winLoss: "500",
    platformFee: "100",
    bonus: "500",
    paymentFee: "17.5",
    commission: "-35.25"
  },
  {
    player: "E",
    deposit: "10000",
    cashout: "20000",
    winLoss: "-10000",
    platformFee: "2000",
    bonus: "10000",
    paymentFee: "1050",
    commission: "-6915"
  }
];
